export default "__VITE_ASSET__de29df87__"